<template>
    <el-dropdown popper-class="custom-dropdown" size="large" ref="dropdown" trigger="click" :show-arrow="false" @visible-change="onVisibleChange">
        <div class="flex items-center cursor-pointer">
            <div class="w-24 h-24 rounded-50% font-600 flex-center mr-8">
                <icon-svg-header></icon-svg-header>
            </div>

            <span>{{ userNickName }}</span>
            <el-icon
                class="el-icon--right !ml-16 transition-all duration-200"
                :class="{
                    ' rotate-180': dropdownVisible,
                }"
                :size="16"
            >
                <icon-svg-down />
            </el-icon>
        </div>

        <template #dropdown>
            <el-dropdown-menu>
                <el-dropdown-item>
                    <div class="flex items-center w-full text-14 mb-4" @click="logout">
                        <!-- <icon-svg-service class="w-16 h-16 mr-4px" /> -->
                        {{ t('login.logout') }}
                    </div>
                </el-dropdown-item>
            </el-dropdown-menu>
        </template>
    </el-dropdown>
</template>

<script setup lang="ts">
import { openLink } from '@/utils/global';
import { clear } from '@/utils/localstorage';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const dropdownVisible = ref(false);
const { getCurrentLocale } = useStore('locale');
const onVisibleChange = (visible: boolean) => {
    dropdownVisible.value = visible;
};
const { clearUser, userNickName, email } = useStore('user');
const router = useRouter();
const route = useRoute();

// 需要登录的页面列表（与 router/index.ts 保持一致）
const loginRequiredPages = ['/OnlineLab'];

const logout = () => {
    clearUser();
    clear();

    const currentPath = route.path;
    // 赛事详情、我的赛事等页面有登录后才展示的内容，退出后需刷新以更新展示
    if (currentPath === '/RaceDetail' || currentPath === '/race-detail-season2' || currentPath === '/my-event') {
        window.location.reload();
        return;
    }
    if (currentPath === '/Register') {
        router.push({ path: '/events', query: { tab: 'competition' } });
        return;
    }
    // 如果当前页面是需要登录的页面，退出后跳转到首页
    if (loginRequiredPages.includes(currentPath)) {
        router.push('/Home');
    }
};

/** 协议 PDF 地址：/docs/files/{语言}/xxx.pdf */
const goPage = (file: string) => {
    openLink(`/docs/files/${getCurrentLocale.value}/${file}`);
};
</script>

<style lang="scss" scoped>
.reset-btn {
    border-color: #bec3cd;

    :deep(.el-button) {
        color: #3e4a54 !important;
    }
    &:hover {
        :deep(.el-button) {
            color: #3967e9 !important;
        }
        border-color: #3967e9;
        .el-icon {
            fill: #3967e9 !important;
        }
    }
    &:active {
        .el-icon {
            fill: #fff !important;
        }
        :deep(.el-button) {
            color: #fff !important;
        }
        border-color: transparent;
        background: #3967e9;
    }
}
</style>
